import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const DeleteTaskDocument = gql`
  mutation DeleteTask($id: String!) {
    deleteTask(id: $id)
  }
`;
export type DeleteTaskMutationFn = ApolloReactCommon.MutationFunction<
  DeleteTaskMutationResponse,
  DeleteTaskMutationVariables
>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteTaskMutationResponse,
    DeleteTaskMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    DeleteTaskMutationResponse,
    DeleteTaskMutationVariables
  >(DeleteTaskDocument, baseOptions);
}
export type DeleteTaskMutationHookResult = ReturnType<
  typeof useDeleteTaskMutation
>;
export type DeleteTaskMutationResult =
  ApolloReactCommon.MutationResult<DeleteTaskMutationResponse>;
export type DeleteTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteTaskMutationResponse,
  DeleteTaskMutationVariables
>;
export type DeleteTaskMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type DeleteTaskMutationResponse = {
  __typename: 'Mutation';
  deleteTask: boolean;
};
